(function () {
  'use strict';

  function loadReviews() {
    var data = window.HBCGoogleReviews;
    if (!data || !Array.isArray(data.reviews)) {
      return Promise.reject(new Error('review-data-unavailable'));
    }
    return Promise.resolve(data.reviews.filter(function (review) {
      return review && review.rating >= 4 &&
        typeof review.name === 'string' && review.name.trim() &&
        typeof review.text === 'string' && review.text.trim();
    }));
  }

  function node(tag, className, text) {
    var item = document.createElement(tag);
    if (className) item.className = className;
    if (typeof text === 'string') item.textContent = text;
    return item;
  }

  function reviewDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return value || 'Google review';
    var parts = value.split('-').map(Number);
    return new Intl.DateTimeFormat('en-GB', {
      month: 'long',
      year: 'numeric',
      timeZone: 'Europe/London'
    }).format(new Date(Date.UTC(parts[0], parts[1] - 1, parts[2], 12)));
  }

  function ReviewsCarousel(root) {
    this.root = root;
    this.track = root.querySelector('[data-reviews-track]');
    this.viewport = root.querySelector('[data-reviews-viewport]');
    this.previous = root.querySelector('[data-reviews-previous]');
    this.next = root.querySelector('[data-reviews-next]');
    this.current = root.querySelector('[data-reviews-current]');
    this.total = root.querySelector('[data-reviews-total]');
    this.progress = root.querySelector('[data-reviews-progress]');
    this.loading = root.querySelector('[data-reviews-loading]');
    this.error = root.querySelector('[data-reviews-error]');
    this.index = 0;
    this.cards = [];
    this.timer = null;
    this.autoplay = root.dataset.autoplay === 'true' &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.delay = (Number(root.dataset.autoplaySeconds) || 7) * 1000;
    this.bind();
    this.load();
  }

  ReviewsCarousel.prototype.bind = function () {
    var self = this;
    this.previous.addEventListener('click', function () { self.move(-1, true); });
    this.next.addEventListener('click', function () { self.move(1, true); });
    this.track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () { self.updateFromScroll(); });
    }, { passive: true });
    this.track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        self.move(-1, true);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        self.move(1, true);
      }
    });
    this.root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-review-expand]');
      if (!button) return;
      var card = button.closest('.hbc-google-reviews__card');
      var expanded = card.classList.toggle('is-expanded');
      button.textContent = expanded ? 'Show less' : 'Read full review';
      button.setAttribute('aria-expanded', String(expanded));
      self.stop();
    });
    this.root.addEventListener('mouseenter', function () { self.stop(); });
    this.root.addEventListener('mouseleave', function () { self.start(); });
    this.root.addEventListener('focusin', function () { self.stop(); });
    this.root.addEventListener('focusout', function () { self.start(); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self.stop();
      else self.start();
    });
  };

  ReviewsCarousel.prototype.load = function () {
    var self = this;
    loadReviews().then(function (reviews) {
      if (!reviews.length) throw new Error('no-reviews');
      self.render(reviews);
      self.loading.hidden = true;
      self.viewport.hidden = false;
      self.update(0);
      self.start();
    }).catch(function () {
      self.loading.hidden = true;
      self.error.hidden = false;
      self.previous.disabled = true;
      self.next.disabled = true;
    });
  };

  ReviewsCarousel.prototype.render = function (reviews) {
    var self = this;
    var fragment = document.createDocumentFragment();
    reviews.forEach(function (review, index) {
      var card = node('article', 'hbc-google-reviews__card');
      card.dataset.reviewIndex = index;

      var top = node('div', 'hbc-google-reviews__card-top');
      var stars = node('div', 'hbc-google-reviews__stars', '★★★★★');
      stars.setAttribute('aria-label', review.rating + ' out of 5 stars');
      var source = node('span', 'hbc-google-reviews__source', 'Google review');
      top.append(stars, source);

      var quote = node('blockquote', 'hbc-google-reviews__quote', review.text.trim());
      var expand = node('button', 'hbc-google-reviews__expand', 'Read full review');
      expand.type = 'button';
      expand.dataset.reviewExpand = '';
      expand.setAttribute('aria-expanded', 'false');

      var reviewer = node('footer', 'hbc-google-reviews__reviewer');
      reviewer.append(
        node('strong', '', review.name.trim()),
        node('span', '', reviewDate(review.date))
      );

      card.append(top, quote);
      if (review.text.length > 320) card.appendChild(expand);
      card.appendChild(reviewer);
      fragment.appendChild(card);
    });
    this.track.replaceChildren(fragment);
    this.cards = Array.from(this.track.children);
    this.total.textContent = String(this.cards.length).padStart(2, '0');
    self.previous.disabled = true;
  };

  ReviewsCarousel.prototype.visibleCards = function () {
    if (!this.cards.length) return 1;
    var width = this.track.clientWidth;
    var cardWidth = this.cards[0].getBoundingClientRect().width;
    return Math.max(1, Math.floor(width / cardWidth));
  };

  ReviewsCarousel.prototype.move = function (amount, userInitiated) {
    if (!this.cards.length) return;
    var max = Math.max(0, this.cards.length - this.visibleCards());
    var target = this.index + amount;
    if (target > max) target = this.autoplay && !userInitiated ? 0 : max;
    if (target < 0) target = 0;
    this.index = target;
    this.track.scrollTo({
  left: this.cards[target].offsetLeft - this.track.offsetLeft,
  behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
});

    this.update(target);
    if (userInitiated) {
      this.stop();
      this.start();
    }
  };

  ReviewsCarousel.prototype.updateFromScroll = function () {
    if (!this.cards.length) return;
    var left = this.track.scrollLeft;
    var closest = 0;
    var distance = Infinity;
    this.cards.forEach(function (card, index) {
      var delta = Math.abs(card.offsetLeft - left - this.track.offsetLeft);
      if (delta < distance) {
        distance = delta;
        closest = index;
      }
    }, this);
    if (closest !== this.index) this.update(closest);
  };

  ReviewsCarousel.prototype.update = function (index) {
    this.index = index;
    var max = Math.max(0, this.cards.length - this.visibleCards());
    this.current.textContent = String(index + 1).padStart(2, '0');
    this.progress.style.width = (((index + 1) / this.cards.length) * 100).toFixed(2) + '%';
    this.previous.disabled = index <= 0;
    this.next.disabled = index >= max;
  };

  ReviewsCarousel.prototype.start = function () {
    var self = this;
    if (!this.autoplay || this.timer || document.hidden || !this.cards.length) return;
    this.timer = window.setInterval(function () { self.move(1, false); }, this.delay);
  };

  ReviewsCarousel.prototype.stop = function () {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = null;
  };

  function initialise(scope) {
    var roots = [];
    if (scope.matches && scope.matches('[data-hbc-google-reviews]')) roots.push(scope);
    roots = roots.concat(Array.from(scope.querySelectorAll('[data-hbc-google-reviews]')));
    roots.forEach(function (root) {
      if (root.dataset.hbcReviewsInitialised) return;
      root.dataset.hbcReviewsInitialised = 'true';
      new ReviewsCarousel(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  } else {
    initialise(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialise(event.target);
  });
})();
